interface IProps {
  className?: string;
  size?: string;
  handleClick?: () => void;
}

const PdfStubIcon = ({ className, size, handleClick }: IProps) => {
  return (
    <svg
      onClick={() => {
        if (handleClick) {
          handleClick();
        }
      }}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      className={className}
      id="mdi-file-pdf-box"
      viewBox="0 0 24 24">
      
      <path id="pdf-stub-icon__assets-icons__path__l22" d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9.5 11.5C9.5 12.3 8.8 13 8 13H7V15H5.5V9H8C8.8 9 9.5 9.7 9.5 10.5V11.5M14.5 13.5C14.5 14.3 13.8 15 13 15H10.5V9H13C13.8 9 14.5 9.7 14.5 10.5V13.5M18.5 10.5H17V11.5H18.5V13H17V15H15.5V9H18.5V10.5M12 10.5H13V13.5H12V10.5M7 10.5H8V11.5H7V10.5Z" />
    </svg>);

};

export { PdfStubIcon };